import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { BlockedModeMessageContainer } from '../styles';
import { ReactComponent as ConnectivityImage } from '../../../../assets/img/remoteControl/connectivity.svg';
import { colors } from '~/styles/remoteControlColors';

export function BlockedModeContainer(): ReactElement {
  const { t } = useTranslation();
  return (
    <BlockedModeMessageContainer>
      <div>
        <ConnectivityImage style={{ height: '120px', width: '120px' }} />
      </div>
      <h2>{t('modoLivreAtivado')}</h2>
      <div style={{ flexDirection: 'column', padding: '0 12px', maxWidth: '284px' }}>
        <p>{t('modoLivreDescricao1')}</p>
        <p style={{ color: colors.Blue700, fontWeight: 600 }}>
          {t('modoLivreDescricao2')}
        </p>
      </div>
    </BlockedModeMessageContainer>
  );
}
